import {Injectable} from "@angular/core";
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup} from "@angular/forms";

@Injectable()
export class GeneralUtils {

  validateFormFields(form: UntypedFormGroup | UntypedFormArray) {
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
        control.markAsDirty({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateFormFields(control);
      } else if (control instanceof UntypedFormArray) {
        this.validateFormFields(control);
      }
    });
  }

  whichIEVersion(): any {
    const myNav = navigator.userAgent.toLowerCase();
    return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
  }

  whichBrowser(): string {
    const browser = window.navigator.userAgent.toLowerCase();
    if (browser.indexOf('edge') > -1) {
      return 'edge';
    } else if (browser.indexOf('opr') > -1) {
      return 'opera';
    } else if (browser.indexOf('chrome') > -1) {
      return 'chrome';
    } else if (browser.indexOf('trident') > -1) {
      return 'ie';
    } else if (browser.indexOf('firefox') > -1) {
      return 'firefox';
    } else if (browser.indexOf('safari') > -1) {
      return 'safari';
    } else {
      return 'other';
    }
  }

  getMonths(): string[] {
    return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  }

  getDays(): any {
    return {
      '01': '1',
      '02': '2',
      '03': '3',
      '04': '4',
      '05': '5',
      '06': '6',
      '07': '7',
      '08': '8',
      '09': '9',
      '10': '10',
      '11': '11',
      '12': '12',
      '13': '13',
      '14': '14',
      '15': '15',
      '16': '16',
      '17': '17',
      '18': '18',
      '19': '19',
      '20': '20',
      '21': '21',
      '22': '22',
      '23': '23',
      '24': '24',
      '25': '25',
      '26': '26',
      '27': '27',
      '28': '28',
      '29': '29',
      '30': '30',
      '31': '31'
    }
  };

}
